import { css } from '@emotion/react'

export const viewOnDark = ({ theme, view, isPressed }) => {
  if (theme === "dark") {
    if (view === "primary" && !isPressed) {
      return css({
        background: "var(--color-grayscale-100)",
        color: "var(--color-grayscale-900)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-37)",
        }
      })
    }
    else if (view === "primary" && isPressed) {
      return css({
        background: "var(--color-grayscale-50)",
        color: "var(--color-grayscale-900)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-100)",
        }
      })
    }

    if (view === "primary-color" && !isPressed) {
      return css({
        background: "var(--color-branding)",
        color: "var(--color-white)",

        "&:hover:not([disabled])": {
          background: "var(--color-destruction-400)",
        }
      })
    }
    else if (view === "primary" && isPressed) {
      return css({
        background: "var(--color-grayscale-50)",
        color: "var(--color-grayscale-900)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-100)",
        }
      })
    }

    else if (view === "indigo" && !isPressed) {
      return css({
        background: "var(--color-indigo-500)",
        color: "var(--color-white)",

        "&:hover:not([disabled])": {
          background: "var(--color-indigo-400)",
          boxShadow: "0px 0px 8px 0px var(--color-indigo-400)",
        }
      })
    }
    else if (view === "indigo" && isPressed) {
      return css({
        background: "var(--color-grayscale-50)",
        color: "var(--color-grayscale-900)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-100)",
        }
      })
    }

    else if (view === "blue" && !isPressed) {
      return css({
        background: "var(--color-primary-600)",
        color: "var(--color-white)",

        "&:hover:not([disabled])": {
          background: "var(--color-primary-500)",
          boxShadow: "0px 0px 8px 0px var(--color-primary-500)",
        }
      })
    }
    else if (view === "blue" && isPressed) {
      return css({
        background: "var(--color-grayscale-50)",
        color: "var(--color-grayscale-900)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-100)",
        }
      })
    }

    else if (view === "secondary" && !isPressed) {
      return css({
        color: "var(--color-grayscale-100)",
        boxShadow: "inset 0 0 0 1px var(--color-grayscale-600)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-750)",
        }
      })
    }
    else if (view === "secondary" && isPressed) {
      return css({
        background: "var(--color-grayscale-50)",
        color: "var(--color-grayscale-900)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-100)",
        }
      })
    }

    else if (view === "simple" && !isPressed) {
      return css({
        color: "var(--color-grayscale-100)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-750)"
        }
      })
    }
    else if (view === "simple" && isPressed) {
      return css({
        background: "var(--color-grayscale-50)",
        color: "var(--color-grayscale-900)",

        "&:hover:not([disabled])": {
          background: "var(--color-grayscale-100)"
        }
      })
    }}
}
